import React from 'react';
import { ReactComponent as SearchMagnifierIcon } from '@mediabank/assets/icons/search-magnifier.svg';
import { ButtonBase } from '@mui/material';
import PropTypes from 'prop-types';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
    root: {
        '& svg': {
            height: '1rem',
            stroke: theme.palette.text.primary,
        },
        '&.MuiButtonBase-root': {
            justifyContent: 'flex-start',
        },
    },
}));

const SearchButton = props => {
    const { label, onClick } = props;
    const { classes } = useStyles();

    return (
        <ButtonBase {...props} className={classes.root} onClick={onClick}>
            <SearchMagnifierIcon />
            {label}
        </ButtonBase>
    );
};

SearchButton.propTypes = {
    label: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

SearchButton.defaultProps = {
    label: '',
};

export default SearchButton;
